<template>
    <b-table
        id="tipoTrpTabela"
        :items="resultado"
        :fields="fields"
        striped
        small
        responsive
        :busy="configTable.load"
        show-empty
        hover
        bordered
        class="mb-0"
        head-variant="light">
        <div slot="table-busy" class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong> Carregando...</strong>
        </div>
        <template slot="empty">
            <p class="my-auto">Nenhuma TRP encontrada.</p>
        </template>
        <template v-slot:head(selecionar)="{ item }">
            <b-form-checkbox v-model="configTable.checkedAll" class="justify-content-center text-center" @change="toggleAll" />
        </template>
        <template v-slot:cell(selecionar)="{ item }">
            <b-form-checkbox class="mx-auto justify-content-center text-center" :checked="selecteds.includes(item.codTipoTrp)" @change="toggleCheck($event, item)" />
        </template>
        <template v-slot:head(1)="{ item }">
            Nome <i class="filter" :class="!isEmpty(filtro.nome) || filtro.filtrarNome == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Nome', 'texto', '', null, $event)"></i>
        </template>
        <template v-slot:cell(1)="{ item }">
            {{ item.descricao }}
        </template>
        <template v-slot:head(2)="{ item }">
            Situação <i class="filter" :class="!isEmpty(filtro.situacao) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Situação', 'radio', 'Ativo,Inativo', null, $event)"></i>
        </template>
        <template v-slot:cell(2)="{ item }">
            {{ item.situacao }}
        </template>
        <template v-slot:head(3)="{ item }">
            REFIS <i class="filter" :class="!isEmpty(filtro.refis) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('REFIS', 'radio', 'Sim,Não', null, $event)"></i>
        </template>
        <template v-slot:cell(3)="{ item }">
            {{ item.refis }}
        </template>
        <template v-slot:head(4)="{ item }">
            Tipos de Crédito <i class="filter" :class="!isEmpty(filtro.tipoCredito) || filtro.filtrarTipoCredito == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Tipos de Crédito', 'texto', '', null, $event)"></i>
        </template>
        <template v-slot:cell(4)="{ item }">
            {{ item.tipoCredito }}
        </template>
        <template v-slot:head(5)="{ item }">
            Prazo de Validade do TRP (dias) <i class="filter" :class="!isEmpty(filtro.prazoValidade) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Prazo de Validade do TRP', 'mascara', '', '##########', $event)"></i>
        </template>
        <template v-slot:cell(5)="{ item }">
            <p class="text-right">
                {{ item.prazoValidade }}
            </p>
        </template>
        <template v-slot:head(6)="{ item }">
            Exige Requisição Paga ou Parcelada <i class="filter" :class="!isEmpty(filtro.exigeRequisicao) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Exige Requisição', 'radio', 'Sim,Não', null, $event)"></i>
        </template>
        <template v-slot:cell(6)="{ item }">
            {{ item.exigeRequisicao }}
        </template>
        <template v-slot:head(7)="{ item }">
            Exige desistência de ações/impug <i class="filter" :class="!isEmpty(filtro.exigeDesistencia) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Exige desistência', 'radio', 'Sim,Não', null, $event)"></i>
        </template>
        <template v-slot:cell(7)="{ item }">
            {{ item.exigeDesistencia }}
        </template>
        <template v-slot:head(8)="{ item }">
            Exige custas pagas <i class="filter" :class="!isEmpty(filtro.exigeCustas) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Exige custas', 'radio', 'Sim,Não', null, $event)"></i>
        </template>
        <template v-slot:cell(8)="{ item }">
            {{ item.exigeCustas }}
        </template>
        <template v-slot:head(9)="{ item }">
            Exige garantia <i class="filter" :class="!isEmpty(filtro.exigeGarantia) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Exige garantia', 'radio', 'Sim,Não', null, $event)"></i>
        </template>
        <template v-slot:cell(9)="{ item }">
            {{ item.exigeGarantia }}
        </template>
        <template v-slot:head(10)="{ item }">
            Valor Mínimo do débito a exigir garantia (R$) <i class="filter" :class="!isEmpty(filtro.valorMinimo) || filtro.filtrarValorMinimo == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Valor Mínimo', 'numerico', '', null, $event)"></i>
        </template>
        <template v-slot:cell(10)="{ item }">
            <p class="text-right" v-if="item.valorMinimo != null">
                {{ item.valorMinimo | currency }}
            </p>
        </template>
    </b-table>
</template>

<script>
    import formatarMixins from '../../mixins/formatarMixins';
    
export default {
    props: ['resultado', 'fields', 'configTable', 'selecteds', 'filtro'],
    mixins: [ formatarMixins ],
    watch: {
        currentPage() {
            this.configTable.checkedAll = false;
            this.$emit('consultar');
        }
    },
    computed: {
        currentPage() {
            return this.configTable.currentPage;
        },
    },
    methods: {
        toggleAll(checked) {
            if(checked) {
                this.resultado.forEach(el => {
                    el.checked = true;
                    if(!this.selecteds.includes(el.codTipoTrp)) {
                        this.selecteds.push(el.codTipoTrp);
                    }
                })
            } else {
                this.resultado.forEach(el => {
                    el.checked = false;
                    if(this.selecteds.includes(el.codTipoTrp)) {
                        const index = this.selecteds.indexOf(el.codTipoTrp);
                        this.selecteds.splice(index, 1);
                    }
                })
            }
        },
        toggleCheck(checked, item) {
            if(checked) {
                item.checked = checked;
                this.selecteds.push(item.codTipoTrp);
            } else {
                item.checked = checked;
                const index = this.selecteds.indexOf(item.codTipoTrp);
                this.selecteds.splice(index, 1);
                this.configTable.checkedAll = false;
            }

        },
        openFilter(campo, tipo, values, mask, event) {
            this.$emit('openFilterPopup', campo, tipo, values, mask, event);
        }
    }

}
</script>

<style scoped>

.no-line {
    white-space: nowrap;
}

</style>
